import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'underscore';

import { clearSpaceContentCountsAction } from '../../actions/spaces/ContentCountsActions';
import { showContentTypes, toggleShowWorkbooksAsViews } from '../../actions/spaces/ContentExplorerFilterActions';
import { selectCurrentlyApplicableContentTypes, selectDefaultContentTypeFilterValues } from '../../selectors/ContentFilterSelectors';
import { selectSelectedContentItems } from '../../selectors/ContentSelectors';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { ProjectSpace, ProjectSpaceDispatchProps, ProjectSpaceOwnProps, ProjectSpaceStateProps } from './ProjectSpace';

const mapStateToProps: MapStateToProps<ProjectSpaceStateProps> = (state: AppState) => ({
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  defaultContentTypeFilterValues: selectDefaultContentTypeFilterValues(state),
  showWorkbooksAsViews: state.contentExplorer.showWorkbooksAsViews,
  urls: siteUrlsSelector(state),
  selectedContentItemsCount: _.values(selectSelectedContentItems(state)).length,
});

const mapDispatchToProps: MapDispatchToProps<ProjectSpaceDispatchProps> = (dispatch) => bindActionCreators({
  filterSelected: showContentTypes,
  toggleShowWorkbooksAsViews: toggleShowWorkbooksAsViews,
  clearContentCounts: clearSpaceContentCountsAction,
}, dispatch);

export const ConnectedProjectSpace: React.ComponentClass<ProjectSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(ProjectSpace);
